export var FETCH_SCHEDULES_DATA_PENDING = "FETCH_SCHEDULES_DATA_PENDING";
export var FETCH_SCHEDULES_DATA_FULFILLED = "FETCH_SCHEDULES_DATA_FULFILLED";
export var FETCH_SCHEDULES_DATA_REJECTED = "FETCH_SCHEDULES_DATA_REJECTED";
export var ADD_SCHEDULE_TRACK = "ADD_SCHEDULE_TRACK";
export var FETCH_SESSION_COLORS = "FETCH_SESSION_COLORS";
export var TRACK_COLORS = [
  {
    maincolor: "#117E15",
    bgcolor: "#C2FFC4",
    subcolor: "#3A883D",
    bordercolor: "#6FEB74",
  },
  {
    maincolor: "#B40424",
    bgcolor: "#FDAFBD",
    subcolor: "#A5122D",
    bordercolor: "#FC5F7C",
  },
  {
    maincolor: "#1192A6",
    bgcolor: "#90E6F3",
    subcolor: "#1F9EB2",
    bordercolor: "#34D1EA",
  },
  {
    maincolor: "#A66C26",
    bgcolor: "#F0D9BC",
    subcolor: "#996B33",
    bordercolor: "#D99F59",
  },
  {
    maincolor: "#9D0691",
    bgcolor: "#FDC4F8",
    subcolor: "#83217A",
    bordercolor: "#F962ED",
  },
  {
    maincolor: "#09219A",
    bgcolor: "#C5CEFC",
    subcolor: "#182C8B",
    bordercolor: "#657DF6",
  },
  {
    maincolor: "#520CD4",
    bgcolor: "#D8C5FC",
    subcolor: "#5922BF",
    bordercolor: "#A578F7",
  },
  {
    maincolor: "#AE430A",
    bgcolor: "#FBCBB2",
    subcolor: "#B84E14",
    bordercolor: "#F58B51",
  },
  {
    maincolor: "#5C5C5C",
    bgcolor: "#E0E0E0",
    subcolor: "#8F8F8F",
    bordercolor: "#B8B8B8",
  },
];
export var ADD_SCHEDULE_TRACK_SESSION = "ADD_SCHEDULE_TRACK_SESSION";
export var SELECT_SCHEDULE_DATE = "SELECT_SCHEDULE_DATE";
export var OPEN_TRACK_MODAL = "OPEN_TRACK_MODAL";
export var OPEN_SESSION_MODAL = "OPEN_SESSION_MODAL";
export var OPEN_SESSION_PRIVATE_USER_MODAL = "OPEN_SESSION_PRIVATE_USER_MODAL";
export var UPDATE_SESSION_FILES = "UPDATE_SESSION_FILES";
export var SESSION_WEEKDAYS = "SESSION_WEEKDAYS";
export var HEIGHT_PER_HOUR = 150;
export var MAX_ZOOM = 10;
export var MIN_ZOOM = 1;
